import { Icon } from "@iconify/react/dist/iconify.js";
import VideoTutorialQuizConfig from "../../components/configuracionTalentos/VideoTutorialQuizConfig";

const FortalezaConfigAdPage = () => (
  <div className="container-fluid">
    <div className="mb-4">
      <h3 className="mb-1 fw-semibold">Configuración adicional — Fortalezas</h3>
      <p className="text-muted mb-0 small">
        Parámetros adicionales del módulo de fortalezas de talentos.
      </p>
    </div>

    <div className="card border-0 shadow-sm radius-8">
      <div className="card-header border-bottom bg-base py-3 px-4">
        <div className="d-flex align-items-center gap-2">
          <span className="bg-primary bg-opacity-10 rounded-circle p-2">
            <Icon icon="mdi:play-circle-outline" width={20} className="text-primary" />
          </span>
          <div className="text-start">
            <h6 className="mb-0 fw-semibold">Video tutorial de fortalezas</h6>
            <small className="text-muted">
              Video guía que verán los estudiantes antes de comenzar el módulo de fortalezas.
            </small>
          </div>
        </div>
      </div>
      <div className="card-body py-4 px-4">
        <VideoTutorialQuizConfig
          tipo="inicio_fortaleza"
          label="Tutorial de Fortalezas de Talentos"
        />
      </div>
    </div>
  </div>
);

export default FortalezaConfigAdPage;
